import type { FeedPage } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { request } from './http';
import { parseFeed } from './schemas';

export const fetchMyFeed = async (signal: AbortSignal | undefined): Promise<FeedPage> => {
  const raw = await request('get', CTL_ENDPOINTS.FEED_ME, { signal });
  const { items, skipped, quiet } = parseFeed(raw);
  return { items, skipped, quiet };
};
